module.exports = __webpack_public_path__ + "images/5074bd32afd1d143c2d5844d2f3837bc.png";